module.exports = __webpack_public_path__ + "img/preview_intercorp.38979384.png";